import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { UserService } from '@fi-app/user/user.service';
import { IAreaToDeleteData, IAreaToDeleteDataItem } from '../area-to-delete-data.model';
import { AppTextService } from '@fi-shared/app-text';
import { ObjectTypesService } from '@fi-app/utilities/fi-services/object-types.service';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'fi-area-delete-select-owner-card',
    templateUrl: './area-delete-select-owner-card.component.html',
    styleUrls: ['./area-delete-select-owner-card.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AreaDeleteSelectOwnerCardComponent implements OnChanges {
    constructor(
        public userService: UserService,
        public appTextService: AppTextService,
        public objectTypesService: ObjectTypesService,
    ) {}

    @Input() area;
    @Input() areaToDeleteData: IAreaToDeleteData;
    @Input() newOwnersModel: any;
    @Input() itemsToChangeOwner: Array<IAreaToDeleteDataItem>;
    @Input() titleText: string;

    @Output('newOwnersModelChange') newOwnersModelChangeEmitter = new EventEmitter<{ [prop: number]: number }>();

    ngOnChanges(changes: SimpleChanges) {
        if (changes.areaToDeleteData) {
            this.updateAreaToDeleteData();
        }
    }

    newOwnerData = [];

    loading$ = new BehaviorSubject(true);

    updateAreaToDeleteData() {
        const loadingPull = [];
        this.newOwnerData = this.itemsToChangeOwner.map((item) => {
            const result = {
                ObjectType: item.ObjectType,
                Title: this.appTextService.get('area_delete.owner_for', {
                    '{x}': item.Count,
                    '{object_type}': this.objectTypesService
                        .GetNameByObjectType(item.ObjectType, item.Count > 1)
                        .toLowerCase(),
                }),
                NewOwnerId: null,
                Users: null,
            };

            loadingPull.push(
                this.userService.getUsersWithModuleAccess(item.ModuleType, AccessRightType.Share).then((users) => {
                    result.Users = users.filter(
                        (user) => this.areaToDeleteData.UserIdsToDelete.indexOf(user.Id) === -1,
                    );
                }),
            );

            return result;
        });

        Promise.all(loadingPull).then(() => {
            this.loading$.next(false);
        });
    }

    newOwnerOnChange() {
        let valid = true,
            newOwnersModel: { [prop: number]: number } = {};
        this.newOwnerData.forEach((item) => {
            if (!item.NewOwnerId) {
                valid = false;
            }
            newOwnersModel[item.ObjectType] = item.NewOwnerId;
        });

        if (valid) {
            this.newOwnersModel = newOwnersModel;
            this.newOwnersModelChangeEmitter.emit(this.newOwnersModel);
        } else if (this.newOwnersModel) {
            this.newOwnersModel = undefined;
            this.newOwnersModelChangeEmitter.emit(this.newOwnersModel);
        }
    }
    // note: not used
    // clearNewOwnerData() {
    //     this.newOwnerData.forEach((item) => {
    //         item.NewOwnerId = null;
    //     });
    // }
}
